import axios from 'axios'
import qs from 'qs'
import { Toast, Dialog } from 'vant'
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router'

// 创建一个axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // withCredentials: true,
  timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // 返回码不正确
    if (res.code !== 200) {
      // 5001订单不存在
      // if (res.code !== 5001) {
      //   Toast.fail(res.msg)
      // }
      // 401未登陆
      if (res.code === 401) {
        // 先检查本地是否有token
        const localToken = getToken()
        if (localToken) {
          // 如果有token但返回401，说明token过期或无效，才清除
          store.dispatch('user/resetToken').then(() => {
            Dialog.alert({
              title: '提示',
              message: '登录已过期，请重新登录'
            }).then(() => {
              router.push({ name: 'Login' })
            })
          })
        } else {
          // 如果没有token，直接跳转登录
          Dialog.alert({
            title: '提示',
            message: '您还未登录，请登录'
          }).then(() => {
            router.push({ name: 'Login' })
          })
        }
        return
      }
      // 订单轮询
      if (res.code === 5001) {
        return Promise.reject(new Error(res.msg || 'Error'))
      }
      if (res.code === 50148) {
        return res
      }
      Toast.fail(res.msg)
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error)
    Toast.fail(error.message)
    return Promise.reject(error)
  }
)

/**
 * 使用 application/x-www-form-urlencoded format
 * @param {*} url
 * @param {*} postData
 * @returns
 */
service.formDataPost = function(url, postData) {
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: qs.stringify(postData),
    url
  }
  return service(options)
}

export default service
